/**
 * Options API mixin for BaseButton: emits one button_click Faro event per
 * click, named "<owner component>#<label key>" (see resolveButtonName).
 */
import i18n from '@/i18n'
import {
  buildTranslationIndex,
  resolveButtonName,
  resolveOwnerName
} from './faroContext'
import { isFaroEnabled, trackButtonClick } from './faro'

/** The BaseButton instance the mixin runs on. */
type TrackedButton = {
  $: Parameters<typeof resolveOwnerName>[0]
  $route?: { name?: unknown }
  title?: unknown
  icon?: string | null
}

const indexes = new WeakMap<object, Map<string, string>>()

function translationIndex(): Map<string, string> {
  const global = i18n.vueI18n?.global
  const messages = global?.getLocaleMessage(global.locale)
  if (!messages) {
    return new Map()
  }
  if (!indexes.has(messages)) {
    indexes.set(messages, buildTranslationIndex(messages))
  }
  return indexes.get(messages)
}

export function buttonTracking(
  tracker: (button: string, route: string) => void = trackButtonClick,
  getIndex: () => Map<string, string> = translationIndex,
  isEnabled: () => boolean = isFaroEnabled
) {
  return {
    methods: {
      faroTrackClick(this: TrackedButton) {
        // Faro off: no name resolution, and the translation index is never built.
        if (!isEnabled()) {
          return
        }
        const button = resolveButtonName(
          {
            owner: resolveOwnerName(this.$),
            title: this.title,
            icon: this.icon
          },
          getIndex()
        )
        const route =
          typeof this.$route?.name === 'string' ? this.$route.name : 'unknown'
        tracker(button, route)
      }
    }
  }
}
